window.wrapLastWord = function wrapLastWord(element) {

    var the_element = $(element),
        word_array,
        last_word,
        first_part;

    the_element.each(function () {
        var $this = $(this);

        word_array = $this.html().split(/\s+/);

        last_word = word_array.pop();
        first_part = word_array.join(' ');

        $this.html([first_part, ' <span class="js_lastWord lastWord">', last_word, '</span>'].join(''));
    });
}

$(document).ready(function () {
    'use strict';

    if ($('.js_wrapLastWord').length) {
        wrapLastWord('.franchiseMenuWrapper .js_wrapLastWord a span');
    }
});